module.exports = __webpack_public_path__ + "static/img/img02.aead230.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv010/img02.jpg
// module id = r7h1
// module chunks = 0